//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { resolveMediaUrl } from '@/utils/mediaUrl'

export default {
  name: 'MyBooks',
  data () {
    return {
      books: [],
      currentBookId: null,
      loading: true
    }
  },
  created () {
    this.loadCurrentBook()
    this.loadBooks()
  },
  methods: {
    coverUrl (img) {
      return resolveMediaUrl(img)
    },
    loadCurrentBook () {
      this.$ajax.post(this.$api.getUserInfo, { key: 'studyBookID' }).then(res => {
        if (res && res.categoryId) this.currentBookId = res.categoryId
      }).catch(() => {})
    },
    loadBooks () {
      this.loading = true
      this.$ajax.get(this.$api.myBooks).then(res => {
        this.books = Array.isArray(res) ? res : []
      }).catch(() => {
        this.books = []
        this.$toast('加载失败')
      }).finally(() => {
        this.loading = false
      })
    },
    isCurrent (item) {
      return this.currentBookId && String(item.categoryId) === String(this.currentBookId)
    },
    studyBook (item) {
      this.$ajax.post(this.$api.setUserInfo, { key: 'studyBookID', value: item.categoryId }).then(() => {
        this.currentBookId = item.categoryId
        this.$router.push({
          path: '/pmsCellList_display',
          query: { value: item.categoryId, label: item.categoryName, source: 'myBooks' }
        })
      }).catch(() => {
        this.$toast('操作失败')
      })
    },
    goBack () {
      this.$router.push({ path: '/mine', query: { hideTrans: 'true' } })
    },
    goActivation () {
      this.$router.push({ path: '/activation', query: { from: 'myBooks' } })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/publicView/me/myBooks.vue